var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"quaggaViewport",staticClass:"viewport",style:(`height: ${_vm.viewportHeight}px;`),attrs:{"id":"interactive"}},[_c('video',{ref:"cameraVideo",attrs:{"playsinline":"","alt":"Barcode Scanner"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }